import React, { useEffect } from 'react';
import { useAuthStore } from '../store/auth';
import { bootstrapSession } from '../lib/auth-api';

/**
 * Tries to silently restore a session on first mount. Renders children
 * unconditionally — components are responsible for reacting to the
 * `status` field in the auth store.
 */
export function AuthProvider({ children }) {
  const status = useAuthStore((s) => s.status);
  useEffect(() => {
    if (status === 'idle') {
      bootstrapSession();
    }
  }, [status]);
  return <>{children}</>;
}
